'use client';

import { LabelDefault, MetaDefault } from '@terra/ui-design-system';
import { ArrowRight01Icon } from '@terra/ui-icons';
import { Box, HStack, VStack, token } from '@terra/ui-styled-system';
import type { MouseEventHandler, ReactNode } from 'react';

type DashboardActionRowProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  trailingContent?: ReactNode;
  showDivider: boolean;
  onClick: () => void;
  onContextMenu?: MouseEventHandler<HTMLElement>;
};

export function DashboardActionRow({
  icon,
  title,
  description,
  trailingContent,
  showDivider,
  onClick,
  onContextMenu,
}: DashboardActionRowProps) {
  return (
    <HStack
      gap={3}
      px={4}
      py={2.5}
      alignItems="center"
      w="full"
      borderTopWidth={showDivider ? '1px' : 0}
      borderTopStyle="solid"
      borderTopColor="border.neutral.subtle"
      cursor="pointer"
      _hover={{ bg: 'bg.neutral.hover' }}
      transition="background-color 0.2s ease-in-out"
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      <Box flexShrink={0} display="flex">
        {icon}
      </Box>
      <VStack gap={0.5} alignItems="flex-start" flex={1} minW={0}>
        <LabelDefault
          color="fg.neutral.default"
          lineClamp={2}
          wordBreak="break-word"
          title={title}
        >
          {title}
        </LabelDefault>
        {description ? (
          <MetaDefault color="fg.neutral.muted">{description}</MetaDefault>
        ) : null}
      </VStack>
      {trailingContent}
      <ArrowRight01Icon size={16} color={token('colors.fg.neutral.muted')} />
    </HStack>
  );
}
